/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useRef } from 'react';
import Select from 'react-select';
import { Modal } from 'react-bootstrap';
import { get, set } from 'lodash';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useTranslation } from 'react-i18next';
import { useCareLabelState } from '../context/index';
import { checkArray, customStyles } from '../../../../Components/helper';
import Loader from '../../../../Components/Utility/Loader/Loader';
import CodeText from './code';
import DiscriptionText from './discription';
import ImgDropzone from '../../../../Components/ImgDropzone/ImgDropzone';
import EditAction from './EditAction';
import ViewAction from './ViewAction';
import CareImage from './careImage';
import ConfirmationPopup from '../../../../Components/ModalPopup/ConfirmationPopup';

function SymbolTable({ CareAddEditAccess, CareDeleteAccess, handleDelete }) {
  const { t } = useTranslation('common');

  const {
    careLabelState,
    setCareLabelState,
    handleCheckAll,
    handleCheckLibrary,
    isallChecked,
    careTypeOption,
    handleInputChange,
    handleSelectChange,
    handleAddUpdate,
    handleClose,
    handleEdit,
    handlePageNextInScroll,
  } = useCareLabelState();
  const { imgPath, CareLabelList, pageLoader, selectedLibrary, editedId, uploadingData, hasMore } = careLabelState;
  const childRef = useRef();
  const [state, setState] = useState({
    imageUpload: false,
    uploadIndex: -1,
    fullImage: null,
    deleteImage: false,
  });

  const handleUploadImage = (index) => {
    const dataList = CareLabelList;
    const fullImage = get(dataList, `[${index}][fullImage]`);

    setState((prevState) => ({
      ...prevState,
      imageUpload: true,
      uploadIndex: index,
      fullImage,
    }));
  };

  const confirmImageUpload = async (type) => {
    if (type !== 'close') {
      const { imageRes, originalImg } = await childRef.current.showCroppedImg();
      const orignalImageres = await originalImg;

      const dataList = CareLabelList;
      set(dataList, `[${state.uploadIndex}][image]`, imageRes);
      set(dataList, `[${state.uploadIndex}][fullImage]`, orignalImageres);
      setCareLabelState((prevState) => ({
        ...prevState,
        CareLabelList: dataList,
      }));
    }

    setState((prevState) => ({
      ...prevState,
      imageUpload: false,
      uploadIndex: -1,
    }));
  };

  const handleDeleteImage = async (index) => {
    setState((prevState) => ({
      ...prevState,
      deleteImage: true,
      uploadIndex: index,
    }));
  };

  const deletCareLabelImage = () => {
    const dataList = CareLabelList;
    set(dataList, `[${state.uploadIndex}][image]`, null);
    set(dataList, `[${state.uploadIndex}][fullImage]`, null);
    set(dataList, `[${state.uploadIndex}][removeImage]`, true);
    setCareLabelState((prevState) => ({
      ...prevState,
      CareLabelList: dataList,
    }));
    setState((prevState) => ({
      ...prevState,
      deleteImage: false,
      uploadIndex: -1,
    }));
  };

  return pageLoader ? (
    <Loader />
  ) : (
    <>
      <div
        id="scrollableDivSymbol"
        className="mt-2"
        style={{
          height: 'calc(100vh - 250px)',
          overflow: 'auto',
        }}
      >
        <InfiniteScroll
          dataLength={CareLabelList?.length}
          hasMore={hasMore}
          next={() => handlePageNextInScroll()}
          scrollableTarget="scrollableDivSymbol"
          className="fixed-col-container"
        >
          <table className="table custom-table layout-fixed fixed-table-th">
            <thead>
              <tr>
                <th className="w-80px w-xs-40px">
                  <div className="checkbox-label no-label margin-auto">
                    <input type="checkbox" name="check_all_symbol" id="check_all_symbol" onChange={(e) => handleCheckAll(e)} checked={isallChecked} />
                    <label htmlFor="check_all_symbol" className="chklabel">
                      <span />
                    </label>
                  </div>
                </th>
                <th className="w-120px">{t('CARE_LABELS.TABLE.SYMBOL_TABLE.IMAGE')}</th>
                <th className="w-300px">{t('CARE_LABELS.TABLE.SYMBOL_TABLE.CODE')}</th>
                <th className="w-300px">{t('CARE_LABELS.TABLE.SYMBOL_TABLE.DESCRIPTION')}</th>
                <th className="w-200px">{t('CARE_LABELS.TABLE.SYMBOL_TABLE.CARE_TYPE')}</th>
                <th className="w-150px">{t('CARE_LABELS.TABLE.SYMBOL_TABLE.ACTION')}</th>
              </tr>
            </thead>
            <tbody>
              {checkArray(CareLabelList) ? (
                CareLabelList.map((eleItem, i) => {
                  const activeType = careTypeOption.find((ele) => ele.id === eleItem.careType);
                  const isEditOpen = eleItem?.editMode && (eleItem._id === editedId || eleItem.newItem);
                  return (
                    <tr key={eleItem?._id}>
                      <td>
                        <div className="checkbox-label no-label margin-auto">
                          <input
                            type="checkbox"
                            name={`symbol_${i}`}
                            id={`symbol_${i}`}
                            checked={selectedLibrary?.includes(eleItem._id)}
                            onChange={(e) => handleCheckLibrary(e.target.checked, eleItem._id)}
                          />
                          <label htmlFor={`symbol_${i}`} className="chklabel">
                            <span />
                          </label>
                        </div>
                      </td>
                      <td className="text-center">
                        <CareImage eleItem={eleItem} handleUploadImage={handleUploadImage} handleDeleteImage={handleDeleteImage} i={i} imgPath={imgPath} />
                      </td>
                      <td>{isEditOpen ? <CodeText eleItem={eleItem} handleInputChange={handleInputChange} i={i} t={t} /> : eleItem.code}</td>
                      <td>{isEditOpen ? <DiscriptionText eleItem={eleItem} handleInputChange={handleInputChange} i={i} t={t} /> : eleItem.description}</td>
                      <td>
                        {isEditOpen ? (
                          <>
                            <Select
                              className="text-dark"
                              options={careTypeOption}
                              styles={customStyles}
                              placeholder={t('CARE_LABELS.TABLE.SYMBOL_TABLE.SELECT_CARE_TYPE')}
                              menuPosition="fixed"
                              getOptionLabel={(option) => `${option.label}`}
                              getOptionValue={(option) => `${option.id}`}
                              name="careType"
                              value={activeType}
                              onChange={(e) => handleSelectChange(e, eleItem, 'careType', i)}
                            />
                            <span className="error-message">
                              {eleItem?.errors?.includes('careType') && t('CARE_LABELS.TABLE.SYMBOL_TABLE.CARE_TYPE_SELECTION_REQUIRED')}
                            </span>
                          </>
                        ) : (
                          eleItem.careType
                        )}
                      </td>
                      <td>
                        <div className="d-flex align-items-center">
                          {isEditOpen ? (
                            <EditAction eleItem={eleItem} handleAddUpdate={handleAddUpdate} handleClose={handleClose} isUploading={uploadingData} />
                          ) : (
                            <ViewAction
                              eleItem={eleItem}
                              handleEdit={handleEdit}
                              handleDelete={handleDelete}
                              i={i}
                              CareAddEditAccess={CareAddEditAccess}
                              CareDeleteAccess={CareDeleteAccess}
                            />
                          )}
                        </div>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan={6}>
                    <p className="text-center m-0">{t('CARE_LABELS.TABLE.SYMBOL_TABLE.LIBRAY_ENTRY_FOUND')}</p>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </InfiniteScroll>
      </div>

      {state.imageUpload && (
        <Modal show={state.imageUpload} backdrop="static" className="common-custom-modal modal-large" aria-labelledby="contained-modal-title-vcenter">
          <form autoComplete="off">
            <Modal.Header>
              <Modal.Title className="f-24">{t('CARE_LABELS.TABLE.SYMBOL_TABLE.UPLOAD_IMAGE')}</Modal.Title>
              <span onClick={() => confirmImageUpload(close)} className="icon-close cursor-pointer" />
            </Modal.Header>
            <Modal.Body>
              {state.imageUpload && (
                <ImgDropzone
                  ref={childRef}
                  onSubmit={confirmImageUpload}
                  image={state.fullImage}
                  acceptedFileExtenstion=".jpeg,.png,.jpg"
                  isEditMode={state.uploadIndex !== -1}
                  title={t('CARE_LABELS.TABLE.SYMBOL_TABLE.CARE_LABEL')}
                />
              )}
            </Modal.Body>
          </form>
        </Modal>
      )}
      {state.deleteImage && (
        <ConfirmationPopup
          onOpen={state.deleteImage}
          onConfirm={() => deletCareLabelImage()}
          // loading={state.loading}
          title={t('CARE_LABELS.TABLE.SYMBOL_TABLE.REMOVE_IMAGE')}
          message={t('CARE_LABELS.TABLE.SYMBOL_TABLE.REMOVE_MESSAGE')}
          toggle={() =>
            setState((beforeDeleteState) => ({
              ...beforeDeleteState,
              deleteId: '',
              deleteImage: false,
            }))
          }
        />
      )}
    </>
  );
}

export default SymbolTable;
